const faNumberFormat = new Intl.NumberFormat("fa-IR");
const faPlainNumberFormat = new Intl.NumberFormat("fa-IR", { useGrouping: false });
const faDateFormat = new Intl.DateTimeFormat("fa-IR", {
  dateStyle: "medium",
  timeZone: "Asia/Tehran",
});
const faLongDateFormat = new Intl.DateTimeFormat("fa-IR", {
  dateStyle: "full",
  timeZone: "Asia/Tehran",
});
const faDateTimeFormat = new Intl.DateTimeFormat("fa-IR", {
  dateStyle: "medium",
  timeStyle: "short",
  timeZone: "Asia/Tehran",
});

export const faNumber = (value: number) => faNumberFormat.format(value);

export const faPlainNumber = (value: number) => faPlainNumberFormat.format(value);

export const faToman = (value: number) => `${faNumberFormat.format(value)} تومان`;

/**
 * faTomanWords: «۲ میلیارد و ۸۵۰ میلیون تومان»؛ برای قیمت خودرو (رقم دقیق faToman در title کنارش)
 * faPercent: «۲۵٪»؛ همان قالب پنل مدیریت
 */
export { faPercent, faTomanWords } from "@car/api/catalog-config";

export const faKm = (value: number) => `${faNumberFormat.format(value)} کیلومتر`;

export const faDate = (iso: string) => faDateFormat.format(new Date(iso));

export const faLongDate = (iso: string) => faLongDateFormat.format(new Date(iso));

export const faDateTimeShort = (iso: string) => faDateTimeFormat.format(new Date(iso));

const faDigits = "۰۱۲۳۴۵۶۷۸۹";
const arDigits = "٠١٢٣٤٥٦٧٨٩";

export const toEnDigits = (value: string) =>
  value
    .replace(/[۰-۹]/g, (d) => String(faDigits.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String(arDigits.indexOf(d)));

export const toFaDigits = (value: string) => value.replace(/[0-9]/g, (d) => faDigits[Number(d)]);

const dayMs = 24 * 60 * 60 * 1000;

export const daysBetween = (fromIso: string, toIso: string) =>
  Math.round((new Date(toIso).getTime() - new Date(fromIso).getTime()) / dayMs);

export const monthsBetween = (fromIso: string, toIso: string) =>
  daysBetween(fromIso, toIso) / 30.44;

const faTimeFormat = new Intl.DateTimeFormat("fa-IR", {
  timeStyle: "short",
  timeZone: "Asia/Tehran",
});

/** «۲۱:۴۰» به وقت تهران */
export const faTime = (iso: string) => faTimeFormat.format(new Date(iso));
